/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionInfoCreate
 */
export interface ProductionInfoCreate {
    /**
     * 
     * @type {boolean}
     * @memberof ProductionInfoCreate
     */
    forceCustomBatesStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionInfoCreate
     */
    regenerateFilesFromOtherDocs?: boolean;
}

export function ProductionInfoCreateFromJSON(json: any): ProductionInfoCreate {
    return ProductionInfoCreateFromJSONTyped(json, false);
}

export function ProductionInfoCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionInfoCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'forceCustomBatesStart': !exists(json, 'forceCustomBatesStart') ? undefined : json['forceCustomBatesStart'],
        'regenerateFilesFromOtherDocs': !exists(json, 'regenerateFilesFromOtherDocs') ? undefined : json['regenerateFilesFromOtherDocs'],
    };
}

export function ProductionInfoCreateToJSON(value?: ProductionInfoCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'forceCustomBatesStart': value.forceCustomBatesStart,
        'regenerateFilesFromOtherDocs': value.regenerateFilesFromOtherDocs,
    };
}


